import React from 'react';
import PropTypes from 'prop-types';
import InvoiceStatusSelector from './c/invoiceStatusSelector/InvoiceStatusSelector';
import columns from './ViewTransactionsColumns';
import GenericGrid from 'shared/components/genericGrid/GenericGrid';
import InvoicesPeriodPicker from './c/invoicesPeriodPicker/InvoicesPeriodPicker';
import SovosIconButton from 's1-ui/sovos-icon-button/SovosIconButton';
import SovosIconMenu from 's1-ui/sovos-icon-menu/SovosIconMenu';
import { neutralWhite, purple } from 's1-ui/themes/sovos-colors';
import RefreshIcon from 'material-ui/svg-icons/navigation/refresh';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import MenuItem from '@material-ui/core/MenuItem';
import Flag from '@material-ui/icons/Flag';
import INVOICE_STATUSES from './c/invoiceStatusSelector/InvoiceStatuses';
import ContextualGridMenuOptions from 'shared/contextualGridMenuOptions/ContextualGridMenuOptions';
import InvoiceFiltersSlidingPanel from './c/invoiceFilters/InvoiceFiltersSlidingPanelConnector';
import InvoiceColumnsSlidingPanel from './c/invoiceColumnsSlidingPanel/InvoiceColumnsSlidingPanel';
import { FilterList, ViewColumn as ManageColumnsIcon  } from '@material-ui/icons';
import InvoiceDialog from '../InvoiceDialog/InvoiceDialog';
import { INVOICE_FILTERS, VISIBLE_INVOICE_COLUMNS, EXTRA_COLUMNS } from 'shared/constants/SharedConstants';
import { INITIAL_FILTERS_STATE, FILTERS, STATUS, PERIOD, PAGE_SIZE } from 'shared/constants/InvoiceFiltersInitialState';
import InvoiceLinesSlidingPanel from './c/invoiceLinesSlidingPanel/InvoiceLinesSlidingPanelConnector';
import { invoiceDynamicColumns } from './c/invoiceColumnsSlidingPanel/InvoiceDynamicColumns';

const ignoredToPosted = "Lines must be Open or Flagged before they can be Posted";
const toPosted = "Lines being moved to Posted will Accrue Tax";
const allToPosted = 'Lines being moved to Posted will Accrue Tax. Ignored lines cannot be changed to Posted until they are in either Open or Flagged';

const fileName = 'Export_Headers.xlsx';

const POSTED_STATUS = INVOICE_STATUSES[1];
const FLAGGED_STATUS = INVOICE_STATUSES[2];
const IGNORE_STATUS = INVOICE_STATUSES[3];
const OPEN_STATUS = INVOICE_STATUSES[4];

const initializeInvoiceFilters = () => ({
  pageSize: 10,
  status: 0,
  period: {
    year: new Date().getFullYear(),
    month: new Date().getMonth()
  },
  filters: INITIAL_FILTERS_STATE
});

let storedInvoiceVisibleColumns;
let storedInvoiceFilters;
let storedExtraColumns;

class ViewTransactionsGrid extends React.Component {
  constructor(props) {
    super(props);
    storedInvoiceVisibleColumns = JSON.parse(sessionStorage.getItem(VISIBLE_INVOICE_COLUMNS));
    storedInvoiceFilters = JSON.parse(sessionStorage.getItem(INVOICE_FILTERS));
    storedExtraColumns = JSON.parse(sessionStorage.getItem(EXTRA_COLUMNS));
    const initialInvoiceFilters = storedInvoiceFilters || initializeInvoiceFilters();
    this.state = {
      invoiceId: 0,
      pageNumber: 0,
      extraColumns: storedExtraColumns ? storedExtraColumns : [],
      openInvoicesLinesSlidingPanel: false,
      openFilterSlidingPanel: false,
      openInvoiceColumnsSlidingPanel: false,
      selectedInvoice: {},
      selectedInvoices: [],
      openDialog: false,
      openDeleteDialog: false,
      fileDownloadID: null,
      fileDownloadName: '',
      message: '',
      invoiceFilters: storedInvoiceFilters || initialInvoiceFilters,
      addedColumnsFlag: storedInvoiceVisibleColumns
        ? storedInvoiceVisibleColumns.some(visibleCol =>
          invoiceDynamicColumns.some(invoiceCol =>
            invoiceCol.name === visibleCol.title
          )
        )
        : false,
      visibleInvoiceColumns: storedInvoiceVisibleColumns
        ? [...columns.filter(column => storedInvoiceVisibleColumns.some(col => col.title === column.title))]
        : [...columns.filter(column => !invoiceDynamicColumns.some(col => col.name === column.title))]
    };
    this.handleFetchData(0, this.state.invoiceFilters.pageSize);
  }

  componentDidMount() {
    !storedInvoiceFilters
      ? sessionStorage.setItem(INVOICE_FILTERS, JSON.stringify(this.state.invoiceFilters))
      : '';
    !storedInvoiceVisibleColumns
      ? sessionStorage.setItem(VISIBLE_INVOICE_COLUMNS, JSON.stringify(this.state.visibleInvoiceColumns))
      : '';
  }

  getPeriodId = (year, month) => {
    const realMonthValue = month + 1;
    return `${year}${(realMonthValue.toString().length === 1) ? '0' : ''}${realMonthValue}`;
  };

  handleFiltersChange = (pageSize, status, year, month) => {
    const period = { year, month };
    const invoiceFilters = this.state.invoiceFilters;
    invoiceFilters[PAGE_SIZE] = pageSize;
    invoiceFilters[STATUS] = status;
    invoiceFilters[PERIOD] = period;
    invoiceFilters[FILTERS] = this.props.appliedFilters;
    this.setState({ invoiceFilters, pageNumber: 0 },
      () => this.handleFetchData(0, pageSize));
    sessionStorage.setItem(INVOICE_FILTERS, JSON.stringify(invoiceFilters));
  };

  handleCloseDialog = () => this.setState({ openDialog: false });

  handleFetchData = (pageNumber, pageSize) => {
    const { period, status } = this.state.invoiceFilters;
    this.props.invoicesActions.fetchInvoices(this.getPeriodId(period.year, period.month), status, pageNumber, pageSize);
  };

  handlePageChange = (pageNumber, pageSize) => {
    const invoiceFilters = {...this.state.invoiceFilters, pageSize};
    this.setState({ pageNumber, invoiceFilters },
      () => this.handleFetchData(pageNumber, pageSize)
    );
    sessionStorage.setItem(INVOICE_FILTERS, JSON.stringify(invoiceFilters));
  };

  handleRowClick = rowData => {
    this.props.invoicesActions.fetchInvoiceById(rowData.id);
    this.setState({
      invoiceId: rowData.id,
      openInvoicesLinesSlidingPanel: true
    });
  };

  handleRowsSelectedClick = rowsIndexes =>
    this.setState(() => ({
      selectedInvoices: [
        ...this.props.invoices
          .filter((invoice, index) => rowsIndexes.includes(index))
          .map(invoice => invoice.id)
      ]
    }));

  handleDeleteInvoices = invoices => {
    const { period, status, pageSize } = this.state.invoiceFilters;
    const { pageNumber } = this.state;
    if(pageSize === invoices.length){
      this.props.invoicesActions.deleteAllInvoices(this.getPeriodId(period.year, period.month), status, pageNumber, pageSize);
    }else{
      this.props.invoicesActions.deleteInvoices(invoices, this.getPeriodId(period.year, period.month), status, pageNumber, pageSize);
    }
    this.handleOpenDialog(false);
  };

  handleReEvaluateInvoices = invoices => {
    const { pageNumber } = this.state;
    const { pageSize, period, status } = this.state.invoiceFilters;
    let periodId = this.getPeriodId(period.year, period.month);
    if(pageSize === invoices.length){
      this.props.taxCalculationActions.calculateTaxesForAllInvoices(periodId, status);
    } else{
      this.props.taxCalculationActions.calculateInvoicesTaxes(invoices);
    }
    this.handleFetchData(pageNumber, pageSize);
  };

  handleCloseInvoiceLinesSlidingPanel = () => {
    const { pageNumber } = this.state;
    const { pageSize } = this.state.invoiceFilters;
    this.setState({ openInvoicesLinesSlidingPanel: false }, () => {
      this.handleFetchData(pageNumber, pageSize);
    });
  };

  handleDownloadTransactions = (file, status) => {
    const extraColumns = this.state.extraColumns;
    const period = this.state.invoiceFilters.period;
    const allItems = [];
    const fileName = `${file.id}_${file.name}`;
    this.props.invoicesActions.exportTransactions(fileName, this.getPeriodId(period.year, period.month), allItems, status, extraColumns);
  };

  handleDownloadSelectedTransactions = (file, selectedInvoices, status) => {
    const extraColumns = this.state.extraColumns;
    const fileName = `${file.id}_${file.name}`;
    const { pageSize, period } = this.state.invoiceFilters;
    let periodId = this.getPeriodId(period.year, period.month);
    const allItems = [];

    if(pageSize === selectedInvoices.length){
      this.props.invoicesActions.exportAllTransactions(fileName, periodId, allItems, status, extraColumns);
    }else{
      this.props.invoicesActions.exportTransactions(fileName, periodId, selectedInvoices, status, extraColumns);
    }
  };

  handleOpenDialog = flag => this.setState({openDeleteDialog: flag});

  showUpdateInvoiceStatusErrorDialogs = (ignoreFlag, invoicesToChange, selectedInvoiceIds,
    ignoreInvoiceQuantity, totalOfStatus, value, prevStatus, periodId, pageNumber, pageSize) => {
    if (ignoreFlag && invoicesToChange.length === 1 && invoicesToChange[0].linesStatus.length > 1 && value === POSTED_STATUS.value) {
      this.setState({openDialog: true, message: allToPosted});
      this.changeInvoicesStatus(prevStatus, selectedInvoiceIds, value, pageNumber, pageSize, periodId);
      this.setState(oldState => ({ ...oldState, status: prevStatus }));
    }

    else if (ignoreFlag && invoicesToChange.length === 1 && invoicesToChange[0].linesStatus.length === 1 && value === POSTED_STATUS.value) {
      this.setState({openDialog: true, message: ignoredToPosted});
      this.setState(oldState => ({ ...oldState, status: prevStatus }));
    }

    else if (ignoreFlag && invoicesToChange.length > 1 && totalOfStatus === ignoreInvoiceQuantity && value === POSTED_STATUS.value) {
      this.setState({openDialog: true, message: ignoredToPosted});
      this.setState(oldState => ({ ...oldState, status: prevStatus }));
    }
    else if (ignoreFlag && invoicesToChange.length > 1 && totalOfStatus > ignoreInvoiceQuantity && value === POSTED_STATUS.value) {
      this.setState({openDialog: true, message: allToPosted});
      this.changeInvoicesStatus(prevStatus, selectedInvoiceIds, value, pageNumber, pageSize, periodId);
      this.setState(oldState => ({ ...oldState, status: prevStatus }));
    }
    else if (!ignoreFlag && ignoreInvoiceQuantity === 0 && value === POSTED_STATUS.value) {
      this.setState({openDialog: true, message: toPosted});
      this.changeInvoicesStatus(prevStatus, selectedInvoiceIds, value, pageNumber, pageSize, periodId);
      this.setState(oldState => ({ ...oldState, status: prevStatus }));
    }
    else {
      this.changeInvoicesStatus(prevStatus, selectedInvoiceIds, value, pageNumber, pageSize, periodId);
      this.setState(oldState => ({ ...oldState, status: prevStatus }));
    }
  }

  getExtraColumns = ( columns ) => {
    const extraColumns = columns.filter( column => column.visible).map( ({ name }) => name );
    this.setState({ extraColumns: [...extraColumns ]});
    sessionStorage.setItem(EXTRA_COLUMNS, JSON.stringify(extraColumns));
  }

  changeInvoicesStatus = (prevStatus, selectedInvoiceIds, value, pageNumber, pageSize, periodId) => {
    const invoiceFilters = { ...this.state.invoiceFilters, status: prevStatus };
    this.props.invoicesActions.changeInvoicesStatus(prevStatus, selectedInvoiceIds, value, pageNumber, pageSize, periodId);
    this.setState({ invoiceFilters });
    sessionStorage.setItem(INVOICE_FILTERS, JSON.stringify(invoiceFilters));
  };

  handleChangeStatusClick = (selectedInvoices, value) => {
    const invoices = this.props.invoices;
    const prevStatus = this.state.invoiceFilters.status;
    const { period, pageSize, status } = this.state.invoiceFilters;
    const { pageNumber } = this.state;
    let periodId = this.getPeriodId(period.year, period.month);
    let ignoreFlag = false;
    let invoicesToChange = [];
    let ignoreInvoiceQuantity = 0;
    let totalOfStatus = 0;

    if(pageSize === selectedInvoices.length){
      if(value === POSTED_STATUS.value){
        this.setState({openDialog: true, message: allToPosted});
        this.setState(oldState => ({ ...oldState, status: prevStatus }));
      }

      this.props.invoicesActions.changeAllInvoicesStatus(periodId, prevStatus, status, pageNumber, pageSize,  value);
    }else {
      invoices.forEach(invoice => {
        if(selectedInvoices.includes(invoice.id)){
          invoicesToChange.push(invoice);
        }
      });
      invoicesToChange.forEach(invoice => {
        totalOfStatus += invoice.linesStatus.length;
        if(invoice.linesStatus.includes("Ignored")){
          ignoreInvoiceQuantity += 1;
          if(value === POSTED_STATUS.value){
            ignoreFlag = true;
          }
        }
      });

      this.showUpdateInvoiceStatusErrorDialogs(ignoreFlag, invoicesToChange,
        selectedInvoices, ignoreInvoiceQuantity, totalOfStatus, value, prevStatus,
        periodId, pageNumber, pageSize);
    }
  };

  handleCloseFilterSlidingPanel = () => {
    const { pageNumber } = this.state;
    const { pageSize } = this.state.invoiceFilters;
    this.setState({ openFilterSlidingPanel: false }, () => {
      this.handleFetchData(pageNumber, pageSize);
    });
  };

  handleCloseInvoiceColumnsSlidingPanel = () => {
    const { pageNumber } = this.state;
    const { pageSize } = this.state.invoiceFilters;
    this.setState({ openInvoiceColumnsSlidingPanel: false }, () => {
      this.handleFetchData(pageNumber, pageSize);
    });
  };

  toggleColumnsVisibility = invoiceColumns => {
    const updatedInvoiceColumns = columns.filter(column => (
      invoiceColumns.find(invColumn => invColumn.name === column.title && invColumn.visible) ||
      !invoiceColumns.find(invColumn => invColumn.name === column.title)
    ));
    this.setState({
      visibleInvoiceColumns: updatedInvoiceColumns,
      addedColumnsFlag: invoiceColumns.find(col => col.visible === true) !== undefined
    });
    sessionStorage.setItem(VISIBLE_INVOICE_COLUMNS, JSON.stringify(updatedInvoiceColumns));
  };

  render() {
    const { invoices, pageState, fetchingInvoices, appliedFiltersFlag } = this.props;
    const {
      invoiceId,
      selectedInvoice,
      selectedInvoices,
      openFilterSlidingPanel,
      openDeleteDialog,
      openInvoicesLinesSlidingPanel,
      openInvoiceColumnsSlidingPanel,
      visibleInvoiceColumns,
      addedColumnsFlag
    } = this.state;
    const { period, status, pageSize } = this.state.invoiceFilters;
    return (
      <React.Fragment>
        <GenericGrid
          data={ invoices }
          columns={ visibleInvoiceColumns }
          totalItems={ pageState.totalEntries }
          onPageChange={ this.handlePageChange }
          initialPageSize={ pageSize }
          pageNumber={ pageState.page }
          onRowClick={ this.handleRowClick }
          onRowSelection={ this.handleRowsSelectedClick }
          loadingData={ fetchingInvoices }
          bulkActionsElements={ [
            <div key={ 'bulk-flag' }>
              <SovosIconMenu
                iconElement={ <Flag/> }
                toolTipText="Update Status"
                style={ {color: 'white'} }
              >
                <MenuItem
                  onClick={ () => this.handleChangeStatusClick(selectedInvoices, POSTED_STATUS.value) }
                >
                  { POSTED_STATUS.primaryText }
                </MenuItem>
                <MenuItem
                  onClick={ () => this.handleChangeStatusClick(selectedInvoices, FLAGGED_STATUS.value) }
                >
                  {FLAGGED_STATUS.primaryText}
                </MenuItem>
                <MenuItem
                  onClick={ () => this.handleChangeStatusClick(selectedInvoices, IGNORE_STATUS.value) }
                >
                  {IGNORE_STATUS.primaryText}
                </MenuItem>
                <MenuItem
                  onClick={ () => this.handleChangeStatusClick(selectedInvoices, OPEN_STATUS.value) }
                >
                  {OPEN_STATUS.primaryText}
                </MenuItem>
              </SovosIconMenu>
            </div>,
            <SovosIconButton
              key={ 'bulk-refresh' }
              TooltipProps={ {title: "Re-evaluate"} }
              onClick={ () => this.handleReEvaluateInvoices(selectedInvoices) }
            >
              <RefreshIcon color={ neutralWhite }/>
            </SovosIconButton>,
            <SovosIconButton
              key={ 'bulk-delete' }
              TooltipProps={ {title: "Delete"} }
              onClick={ () => this.handleOpenDialog(true) }>
              <DeleteIcon color={ neutralWhite }/>
            </SovosIconButton>
          ] }
          toolBarElements={ [
            <InvoicesPeriodPicker
              key={ 'period-selector' }
              onChange={ (year, month) => this.handleFiltersChange(pageSize, status, year, month) }
              yearsBefore={ 2 }
              yearsBeyond={ 1 }
              selectedYear={ period.year }
              selectedMonth={ period.month }
            />,
            <InvoiceStatusSelector
              key={ 'status-selector' }
              value={ status }
              onStatusChange={ status => this.handleFiltersChange(pageSize, status, period.year, period.month) }
            />,
            <SovosIconButton
              key={ 'filter-menu' }
              TooltipProps={ { title: "Filters" } }
              onClick={ () => this.setState({ openFilterSlidingPanel: true }) }
              style={ { backgroundColor: appliedFiltersFlag ? purple : neutralWhite, borderRadius: 0, margin: '10px' } }
              color={ appliedFiltersFlag ? neutralWhite : purple }
            >
              <FilterList/>
            </SovosIconButton>,
            <SovosIconButton
              key={ 'manage-columns-menu' }
              TooltipProps={ { title: "Manage Columns" } }
              onClick={ () => this.setState({ openInvoiceColumnsSlidingPanel: true }) }
              style={ { backgroundColor: addedColumnsFlag ? purple : neutralWhite, borderRadius: 0, margin: '10px' } }
              color={ addedColumnsFlag ? neutralWhite : purple }
            >
              <ManageColumnsIcon />
            </SovosIconButton>,
            <ContextualGridMenuOptions
              key={ 'download-selector' }
              elementId={ selectedInvoice }
              downloadSelectedDisabled={ false }
              downloadAllDisabled={ false }
              selectedItems={ selectedInvoices }
              fontSize={ '13px' }
              onDownloadSelected={ () => this.handleDownloadSelectedTransactions({
                id: this.getPeriodId(period.year, period.month),
                name: fileName
              }, selectedInvoices, status) }
              onDownloadAll={ () => this.handleDownloadTransactions({
                id: this.getPeriodId(period.year, period.month),
                name: fileName
              }, status) }
            />
          ] }
        />
        <InvoiceLinesSlidingPanel
          open={ openInvoicesLinesSlidingPanel }
          onCloseSlidingPanel={ this.handleCloseInvoiceLinesSlidingPanel }
          invoiceId={ invoiceId }
          selectedInvoice={ selectedInvoice }
          periodId={ this.getPeriodId(period.year, period.month) }
        />
        <InvoiceFiltersSlidingPanel
          title="Filters"
          open={ openFilterSlidingPanel }
          onClose={ this.handleCloseFilterSlidingPanel }
          baseWidth={ '280px' }
        />
        <InvoiceColumnsSlidingPanel
          title="Columns"
          open={ openInvoiceColumnsSlidingPanel }
          onClose={ this.handleCloseInvoiceColumnsSlidingPanel }
          baseWidth={ '280px' }
          onToggleColumnsVisibility={ this.toggleColumnsVisibility }
          visibleInvoiceColumns={ visibleInvoiceColumns }
          onGetExtraColumns={ this.getExtraColumns }
        />
        <InvoiceDialog
          open={ openDeleteDialog }
          message="Are you sure you want to delete these Invoices?"
          onClose={ () => this.handleOpenDialog(false) }
          onContinue={ () => this.handleDeleteInvoices(selectedInvoices) }
          cancelButton="CLOSE"
          okButton="CONTINUE"
        />
        <InvoiceDialog
          open={ this.state.openDialog }
          message={ this.state.message }
          onClose={ this.handleCloseDialog }
          cancelButton="CLOSE"
        />
      </React.Fragment>
    );
  }
}

ViewTransactionsGrid.propTypes = {
  invoices: PropTypes.array.isRequired,
  fetchingInvoices: PropTypes.bool,
  pageState: PropTypes.object.isRequired,
  appliedFilters: PropTypes.array.isRequired,
  appliedFiltersFlag: PropTypes.bool,
  taxCalculationActions: PropTypes.shape({
    calculateInvoicesTaxes: PropTypes.func,
    calculateTaxesForAllInvoices: PropTypes.func
  }),
  invoicesActions: PropTypes.shape({
    fetchInvoices: PropTypes.func,
    deleteInvoices: PropTypes.func,
    exportTransactions: PropTypes.func,
    changeInvoicesLinesStatus: PropTypes.func,
    changeInvoicesStatus: PropTypes.func,
    fetchInvoiceById: PropTypes.func,
    deleteAllInvoices: PropTypes.func,
    changeAllInvoicesStatus: PropTypes.func,
    exportAllTransactions: PropTypes.func
  }).isRequired
};

ViewTransactionsGrid.defaultProps = {
  fetchingInvoices: false
};

export default ViewTransactionsGrid;



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/ViewTransactionsGrid.js